import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import {
  AreaFour,
  Links,
  LogoutButton,
  LogoutLink
  } from './Style';
import { auth } from '../../utils/auth';
import { FormattedMessage } from 'react-intl';
import { setPageLoader } from '../../constants/loader';
import { useEffect, useId } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';


function LogoutMenuLinks() {
  const componentId = useId();
  
  const theme = useTheme();
  const isSmallScreenBreakpoint = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.xs),
  );

  const handleLogout = () => {
    setPageLoader(componentId, true);
    auth.logout();
  };

  useEffect(() => {
    return () => {
      setPageLoader(componentId, false);
    };
  }, []);

  return (
    <AreaFour whiteBackground={!isSmallScreenBreakpoint}>
      <Links>
        <ViewOnScreen screen={{ down: 'xs' }}>
          <LogoutLink onClick={handleLogout}>
            <FormattedMessage id={'userDropdown.links.logout'} />
          </LogoutLink>
        </ViewOnScreen>
        <ViewOnScreen screen={{ up: 'xs' }}>
          <LogoutButton onClick={handleLogout}>
            <FormattedMessage id={'userDropdown.links.logout'} />
          </LogoutButton>
        </ViewOnScreen>
      </Links>
    </AreaFour>
  );
}

export default LogoutMenuLinks;